import * as React from 'react';
import request from '@/server/request';
import config from '@/server/config';
import './scss/index.scss'
import * as utils from '@/server/utils';

export default class InquiryMessage extends React.Component < any, any > {
    loading = false;
    loadOver = false;
    constructor(props: any) {
        super(props);
        const id = Number(utils.getQueryString('id') || 0);
        this.state = {
            id,
            page: 1, // 页码
            list: []
        };
    }

    componentDidMount() {
    	this.getData()
        window.onscroll = () => {
            if (document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 50 || document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 50) {
                if (this.loading || this.loadOver) {
                    return;
                }

                this.setState({
                    page: this.state.page + 1,
                }, () => {
                    this.getData()
                });
            }
        }
    }

    render() {
        return (
            <div className="page-inquiryMessage">
        <div className="tab-view">

          <div className="tab-panel active">
            <div className="inquiry-list">
            	{
            		this.state.list.map((v: any) => {
            			return (
            				<div className="inquiry-card" key={v.offer_sample_id} onClick={() => this.props.history.push('/inquiry/details?id='+v.offer_sample_id)}>
				                <ul className="info-list">
				                  <li className="info-row"><span className="label">索样产品</span><span className="text line-clamp-1">{v.goods_name}</span></li>
				                  <li className="info-row"><span className="label">企业名称</span><span className="text line-clamp-1">{v.company_name}</span></li>
				                  <li className="info-row"><span className="label">联系人</span><span className="text line-clamp-1">{v.company_linkman}</span></li>
				                  <li className="info-row"><span className="label">联系电话</span><span className="text line-clamp-1">{v.company_tel}</span>
				                  </li>
				                  <li className="info-row"><span className="label">状态</span><span className="text line-clamp-1">{v.sample_status_name}</span>
				                  </li>
				                  <li className="info-row"><span className="label">留言时间</span><span className="text line-clamp-1">{v.created_at}</span></li>
				                </ul>
				                <div className="buttom-text"><span className="text">查看详情</span><i className="icon"></i></div>
				              </div>
            			)
            		})
            	}
            </div>
          </div>
          {
			!this.state.list.length ?
				<div className="upgrade">
					<div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>暂无内容</p></div>
				</div> : ''

		}
        </div>
      </div>
        )
    }

    private async getData() {
        this.loading = true
    	const r = await request({
            method: "get",
            url: `${config.MALLAPI}api/wshop/sample/offer-list?sampleId=${this.state.id}&page=${this.state.page}`,
        })
        if (r.error_code === 0) {
        	this.setState({
        		list: this.state.list.concat(r.data.data)
        	})
            if (r.data.current_page >= r.data.page_count) {
                this.loadOver = true
            }
            this.loading = false
        }
    }
}